"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
exports.getIndividualResults = function (args, pollingInterval) { return ({
    type: types_1.ResultActionTypes.GET_INDIVIDUAL_RESULTS,
    args: args,
    pollingInterval: pollingInterval
}); };
exports.getIndividualResultsSubscribed = function (action) { return (__assign({}, action, { type: types_1.ResultActionTypes.GET_INDIVIDUAL_RESULTS_SUBSCRIBED })); };
exports.getIndividualResultsUpdate = function (action) { return (__assign({}, action, { type: types_1.ResultActionTypes.GET_INDIVIDUAL_RESULTS_UPDATE })); };
exports.getIndividualResultsStop = function (args) { return ({
    type: types_1.ResultActionTypes.GET_INDIVIDUAL_RESULTS_STOP,
    args: args
}); };
exports.getIndividualResultsError = function (action) { return (__assign({}, action, { type: types_1.ResultActionTypes.GET_INDIVIDUAL_RESULTS_ERROR })); };
//# sourceMappingURL=individualResults.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlinks-results-client/dist/src/actions/external/individualResults.js
 ** module id = 943
 ** module chunks = 0
 **/